export default __webpack_public_path__ + "static/media/tour-highlighting.9b80e6d9.svg";